import React, { useState, useEffect, useContext, useMemo } from "react";
import { Redirect, Link } from "react-router-dom";
import axios from "axios";
import {
  MultiselectCheckbox,
  CustomSelect,
  IntInput,
} from "components/Input/Index.js";
import ActionPlansContext from "context/ActionPlansContext";
import ActionContext from "context/ActionContext";
import _ from "lodash";
import useApi from "api/useApi";
import styled from "styled-components";
import UserService from "services/UserService";
import { getSite } from "services/ConfigServices";
import { batiment } from "variables/patrimoine.js";

const TableName = styled.div`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

export default function useActionTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const actionplanupdate = permis.includes("actionplan_update");
  const [totalRows, setTotalRows] = useState(0);
  const [results, setResults] = useState();
  const [isRefetched, setIsRefetched] = useState(false);

  const appContext = useContext(ActionPlansContext);
  const { actionPlans } = appContext;
  const appContext2 = useContext(ActionContext);
  const { action, setAction } = appContext2;
  const [selectedENRid, setSelectedENRid] = useState("");
  const [selectedENR, setSelectedENR] = useState([]);

  const [ENRData, setENRData] = useState([]);

  const refreshTable = () => {
    setIsRefetched(!isRefetched);
  };

  const handleENRChange = (e) => {
    const { value } = e.target;
    setAction((prevState) => ({
      ...prevState,
      parameters: {
        ...prevState.parameters,
        impact: {
          ...prevState.parameters?.impact,
          renewabletype: value,
        },
      },
    }));
    setSelectedENRid(value);
  };

  useEffect(() => {
    setSelectedENRid(action?.parameters?.impact?.renewabletype);
  }, [ENRData]);

  useEffect(() => {
    getENRData("renewables.synthesis");
  }, [isRefetched]);

  useEffect(() => {
    let enr = ENRData.find((enr) => enr.id == selectedENRid);
    enr !== undefined && setSelectedENR([enr]);
  }, [selectedENRid,ENRData]);

  const getENRData = async (route) => {
    let data = [];

    await axios
      .get(getSite(action.parameters.general.groups[0], route), {
        headers: {
          Authorization: `Bearer ${UserService.getToken()}`,
        },
      })
      .then((res) => {
        data = res?.data?.detail?.renewables?.synthesis || [];
      });

    filterData(data);
  };

  function filterData(data) {
    let filteredData = [];
    if (data.solarthermal) {
      filteredData.push({
        name: batiment.renewables.synthesis.solarthermal,
        id: "solarthermal",
        surface: data.solarthermalroofsurface,
        compatibility: data.solarthermalheatingcompatibility,
        faisability: data.solarthermalfaisability,
      });
    }
    if (data.pv) {
      filteredData.push({
        name: batiment.renewables.synthesis.pv,
        id: "pv",
        surface: data.pvroofsurface,
        compatibility: data.pvheatingcompatibility,
        faisability: data.pvfaisability,
      });
    }
    if (data.geothermal) {
      filteredData.push({
        name: batiment.renewables.synthesis.geothermal,
        id: "geothermal",
        surface: data.geothermalgroundavailablesurface,
        compatibility: data.geothermalcompatibility,
        faisability: data.geothermalfaisability,
      });
    }
    if (data.biomass) {
      filteredData.push({
        name: batiment.renewables.synthesis.biomass,
        id: "biomass",
        surface: data.biomassgroundavailablesurface,
        compatibility: data.biomassheatingcompatibility,
        faisability: data.biomassfaisability,
      });
    }
    setENRData(filteredData);
  }

  // ----------------------------------------------------------

  const SubHeaderComponent = () => {
    return (
      <>
        <TableName></TableName>
        {actionplanupdate && (
          <CustomSelect
            inputTitle={"Type ENR"}
            selectValue={action?.parameters?.impact?.renewabletype || ""}
            handleSelectValueChange={handleENRChange}
            data={ENRData}
            name="renewabletype"
            width="11rem"
          />
        )}
      </>
    );
  };

  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  return {
    gridState: {
      defaultPageSize: 10,
      data: selectedENR,
      paginationTotalRows: totalRows,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      //title: headerComponentMemo,
      subHeaderComponent: <SubHeaderComponent />,
    },
    refreshTable,
  };
}
